import Service from "../../services";
import Swal from "sweetalert2";

const OptionsModule = {
  namespaced: true,
  state: {
    categories: [],
    habits: [],
    habitats: [],
    benefits: [],
    knowledge_level1s: [],
    // knowledge_level2s: [],
    knowledge: [],
    district_bank: [],
    sub_district_bank: [],
    province_bank: [],
    district_survey: [],
    sub_district_survey: [],
    province_survey: [],

    district: [],
    sub_district: [],
    province: [],
    community: [],
    status: [],
    publish: [],
    plant: [],
    bio: [],
    survey: [],
    bank: [],
  },

  mutations: {
    SET_OPTIONS(state, data) {
      state.categories = data.categories;
      state.habits = data.habits;
      state.habitats = data.habitats;
      state.benefits = data.benefits;
      state.knowledge_level1s = data.knowledge_level1s;
      // state.knowledge_level2s = data.knowledge_level2s;
      state.knowledge = data.knowledge;

      // state.district_survey = data.district;
      // state.sub_district_survey = data.sub_district;
      // state.province_survey = data.province;
      //
      // state.district_bank = data.district;
      // state.sub_district_bank = data.sub_district;
      // state.province_bank = data.province;

      state.district = data.district;
      state.sub_district = data.sub_district;
      state.province = data.province;
      state.community = data.community;
      state.plant = data.plant;
      state.survey = data.survey;
      state.bank = data.bank;
      state.status = data.status;
      state.publish = data.publish;
    },
    SET_BIO(state, data) {
      state.bio = data;
    },
    GET_DISTRICTS_SURVEY(state, data) {
      console.log("data", data);
      state.district_survey = [];
      state.district_survey = data;
      console.log("state.district_survey", state.district_survey);
    },
    GET_SUB_DISTRICTS_SURVEY(state, data) {
      state.sub_district_survey = [];
      state.sub_district_survey = data;
      console.log("state.sub_district_survey", state.sub_district_survey);
    },
    GET_DISTRICTS_BANK(state, data) {
      state.district_bank = [];
      state.district_bank = data;
      console.log("state.district_bank", state.district_bank);
    },
    GET_SUB_DISTRICTS_BANK(state, data) {
      state.sub_district_bank = [];
      state.sub_district_bank = data;
      console.log("state.sub_district_bank", state.sub_district_bank);
    },
  },
  actions: {
    onGetCommunityOption({ commit }, data) {
      return Service.OptionsAPI.getOptionCommunity(data).then((res) => {
        if (res.code == 200) {
          commit("SET_OPTIONS", res.result);
          return res.result;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
            text: res.message,
          });
        }
      });
    },
    onGetOption({ commit }, data) {
      return Service.OptionsAPI.getOptions(data).then((res) => {
        if (res.code == 200) {
          commit("SET_OPTIONS", res.result);
          return res.result;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
            text: res.message,
          });
        }
      });
    },
    onGetOptionPlant({ commit }, data) {
      return Service.OptionsAPI.getOptionsPlant(data).then((res) => {
        if (res.code == 200) {
          commit("SET_OPTIONS", res.result);
          console.log("res.result", res.result);
          return res.result.plant;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
            text: res.message,
          });
        }
      });
    },
    onGetDataPlant({ commit }, id) {
      return Service.OptionsAPI.getDataPlant(id).then((res) => {
        if (res) {
          commit("SET_BIO", res);
          return res;
        }
      });
    },
    setFilterDistrict({ commit }, data) {
      if (data.name == "survey") {
        commit("GET_DISTRICTS_SURVEY", data.filter);
      }
      if (data.name == "bank") {
        commit("GET_DISTRICTS_BANK", data.filter);
      }
    },
    setFilterSubDistrict({ commit }, data) {
      if (data.name == "survey") {
        commit("GET_SUB_DISTRICTS_SURVEY", data.filter);
      }
      if (data.name == "bank") {
        commit("GET_SUB_DISTRICTS_BANK", data.filter);
      }
    },
  },
};

export default OptionsModule;
